import { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";

const useTabs = (isPersistent, defaultTab, isDesktop, _tab = 0) => {
    const { pathname, state = { tab: _tab } } = useLocation();
    const [currentTabIndex, setCurrentTabIndex] = useState(defaultTab || state.tab);
    const history = useHistory();
    const regex = /[a-zA-z0-9]+/;
    const path = pathname.match(regex)[0];

    useEffect(() => {
        if (!isPersistent && isDesktop) {
            history.replace({ pathname, state: { ...state, tab: currentTabIndex } });
        } else if (!isPersistent && currentTabIndex !== state.tab) {
            history.replace({ pathname, state: { ...state, tab: currentTabIndex } });
        }
    }, [currentTabIndex]);

    useEffect(() => {
        const selected = sessionStorage.getItem(`tab-${path}`);
        if (isPersistent && selected) {
            setCurrentTabIndex(selected * 1);
        }
    }, [isPersistent]);

    useEffect(() => {
        if (isPersistent) {
            sessionStorage.setItem(`tab-${path}`, currentTabIndex);
        }
    }, [isPersistent, currentTabIndex]);
    return { currentTabIndex, setCurrentTabIndex };
};

export default useTabs;
